module.exports = __webpack_public_path__ + "img/科研单位.76763b51.png";